import { type RefObject } from "react";
import { ApplicationForm } from "@components/job_post/application_form";
import { ApplicationSuccess } from "@components/job_post/application_success";
import type { JobPostDetail } from "@/types/job_search/detail";
import type { JobDescriptionSummary } from "@/utils/job_description_summary.ts";

type Props = {
  detail: JobPostDetail;
  submitted: boolean;
  onSuccess: () => void;
  onViewJobs: () => void;
  dirtyRef: RefObject<() => boolean>;
  summary?: JobDescriptionSummary | null;
  onCreateAlert?: () => void;
};

export const ApplyContents = ({
  detail,
  submitted,
  onSuccess,
  onViewJobs,
  dirtyRef,
  summary,
  onCreateAlert,
}: Props) => {
  const { jobPost, submitPath, boardConfiguration, educationApiUrl, dreamJobAvailable } = detail;

  if (submitted) {
    return <ApplicationSuccess jobPost={jobPost} onViewJobs={onViewJobs} />;
  }

  return (
    <ApplicationForm
      jobPost={jobPost}
      questions={jobPost.questions}
      submitPath={submitPath}
      boardConfiguration={boardConfiguration}
      onSuccess={onSuccess}
      educationApiUrl={educationApiUrl}
      dreamJobAvailable={dreamJobAvailable}
      summary={summary}
      onCreateAlert={onCreateAlert}
      dirtyRef={dirtyRef}
    />
  );
};

export default ApplyContents;
